<script lang="ts" setup>
import { useBrowserStore } from '@apps/main/new-desktop/core/stores';
import { i18n } from '@apps/main/modules/localization/localizationSetup';
import type { AppMultiSelectSelectedPlaceholder } from 'libs/ui/src/lib/components/selects/models/multi.model';

import type { AppMultiSelectOption, AppMultiSelectType } from '@libs/ui';
import { AppMultiSelect } from '@libs/ui';
import type { BoardBasisCode } from '@libs/trip-planner-interfaces';

import type { HotelFilterMealsUpdate } from '../../model/hotelFilters';

import { getMealTypeForFilter } from './hotelMealFilters.helper';

const { t } = i18n.global;

interface HotelMealFiltersProps {
  type: AppMultiSelectType;
  options: AppMultiSelectOption<BoardBasisCode>[];
  shouldShowClearButton: boolean;
  useTeleport?: boolean;
  selectedPlaceholderFormat?: AppMultiSelectSelectedPlaceholder;
  selectedPlaceholder?: string;
  isWrapperScrolling?: boolean;
}

const props = defineProps<HotelMealFiltersProps>();

interface HotelMealFiltersEmits {
  (eventName: 'meal-option-selected', value: HotelFilterMealsUpdate): void;
  (eventName: 'clear-selection'): void;
}

const emit = defineEmits<HotelMealFiltersEmits>();

const browserStore = useBrowserStore();

function onSelectOption(
  selectedOption: AppMultiSelectOption<BoardBasisCode>
): void {
  emit('meal-option-selected', {
    type: getMealTypeForFilter(selectedOption.id),
    value: !!selectedOption.selected,
  });
}

function deselectAll(): void {
  props.options.forEach((option) => {
    if (option.selected) {
      emit('meal-option-selected', {
        type: getMealTypeForFilter(option.id),
        value: false,
      });
    }
  });
}
</script>

<template>
  <AppMultiSelect
    :type="props.type"
    :placeholder="t('planner.show_all_meals')"
    :should-show-clear-button="props.shouldShowClearButton"
    :is-wrapper-scrolling="props.isWrapperScrolling"
    :selected-placeholder="props.selectedPlaceholder"
    :selected-placeholder-format="props.selectedPlaceholderFormat"
    :options="props.options"
    :use-teleport="props.useTeleport"
    :wide="browserStore.isSmallerThan900px"
    @select-single="onSelectOption"
    @clear-selection="deselectAll"
  />
</template>
